import { Link } from '@tanstack/react-router'

import { useTranslate } from '@/shared/i18n/I18nProvider'

/**
 * Reached by every path the route table does not define, including protected
 * areas the current session cannot enter. Those are absent rather than hidden:
 * no route render, no protected chrome.
 */
export function NotFoundPage() {
  const t = useTranslate()
  return (
    <main id="main" className="panel panel--notfound">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.detail')}</p>
      <Link to="/" className="button">
        {t('notFound.back')}
      </Link>
    </main>
  )
}
